<h5 class="mobile-nav-title" i18n>Jobs</h5>
<div class="container-fluid mb-5">
  <form class="row" (ngSubmit)="loadJobs()">
    <div class="col-sm-3">
      <input name="projectName" id="projectName"
             class="form-control" placeholder="Search Projects" i18n-placeholder
             [(ngModel)]="filter.projectName" #projectName="ngModel" />
    </div>
    <div class="col-sm-3">
      <select name="dateRange" id="dateRange"
              class="form-control select-bidit"
              [(ngModel)]="filter.convertedDateRange" #dateRange="ngModel">
        <option value="undefined" i18n>Select Converted Date Range</option>
        <option value="1" i18n>Current Month</option>
        <option value="2" i18n>Current Quarter</option>
        <option value="3" i18n>Current Year</option>
        <option value="4" i18n>Prior Month</option>
        <option value="5" i18n>Prior Quarter</option>
        <option value="6" i18n>Prior Year</option>
      </select>
    </div>
    <div class="col-sm-3">
      <select name="dateRange" id="dateRange"
              class="form-control select-bidit"
              [(ngModel)]="filter.startDateRange" #dateRange="ngModel">
        <option value="undefined" i18n>Select Start Date Range</option>
        <option value="1" i18n>Current Month</option>
        <option value="2" i18n>Current Quarter</option>
        <option value="3" i18n>Current Year</option>
        <option value="4" i18n>Prior Month</option>
        <option value="5" i18n>Prior Quarter</option>
        <option value="6" i18n>Prior Year</option>
      </select>
    </div>
    <div class="col-sm-3">
      <select name="jobTypeId" id="jobTypeId"
              class="form-control select-bidit"
              [(ngModel)]="filter.jobTypeId" #jobTypeId="ngModel">
        <option [ngValue]="null" i18n>Select Job Type</option>
        <option *ngFor="let jobType of summary?.jobTypes" [ngValue]="jobType.jobType_ID">{{jobType.jobType_Desc}}</option>
      </select>
    </div>
    <div class="col-sm-3">
      <select name="salespersonId" id="salespersonId"
              class="form-control select-bidit"
              [(ngModel)]="filter.salespersonId" #salespersonId="ngModel">
        <option value="" i18n>Select Salesperson</option>
        <option *ngFor="let salesperson of summary?.salespersons" [ngValue]="salesperson.id">{{salesperson.lastName}}, {{salesperson.firstName}}</option>
      </select>
    </div>
    <div class="col-sm-3">
      <select name="statusId" id="statusId"
              class="form-control select-bidit"
              [(ngModel)]="filter.statusId" #salespersonId="ngModel">
          <option [ngValue]="undefined" i18n>Select Status</option>
        <option value="1" selected i18n>Active Jobs</option>
        <option value="2" i18n>Completed Jobs</option>
        <option value="3" i18n>In Progress Jobs</option>
        <option value="4" i18n>Not Scheduled Jobs</option>
        <option value="5" i18n>Scheduled Jobs</option>
        <option value="6" i18n>Canceled Jobs</option>
        <option [ngValue]="undefined" i18n>All Statuses</option>
      </select>
    </div>
    <div class="col-sm-3">
      <button type="submit" class="text-white float-right btn btn-bidit-navigate" i18n>Apply Filter</button>
    </div>
  </form>
  <h5 class="col mb-3" i18n>Jobs</h5>
  <div
        infiniteScroll
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="50"
        (scrolled)="onScroll()">
    <div *ngFor="let job of jobs">
      <div class="card bg-light border-bidit-dark mb-3 shadow">
        <div class="card-body text-bidit-primary">
          <div class="col">
            <span class="text-bidit-primary-header">{{job.customer?.customer_BusinessName}}</span>
          </div>
          <span class="form-inline col">
            <label for="quoteName" i18n>Project Name:</label>
            <a class="mobile-link" routerLink="/job/{{job.quote_ID}}">
              {{job.quote_Name}} #{{job.quote_ProjectNumber}}
            </a>
          </span>
          <div class="col">
            <div class="row">
              <div class="col-6">
                <div class="form-inline" *ngIf="!isFieldTech">
                  <label for="quote_BidAmount" i18n>Bid Amount:</label>
                  <span id="quote_BidAmount">{{job.quote_BidAmount | currency}}</span>
                </div>
                <div *ngFor="let quoteAssignment of job.quoteAssignments">
                    <div *ngIf="quoteAssignment.assignedTo" class="form-inline">
                        <label for="salesPerson" i18n>Salesperson:</label>
                        <span id="salePerson">
                            {{quoteAssignment.assignedTo.lastName}}, {{quoteAssignment.assignedTo.firstName}}
                        </span>
                    </div>
                </div>
              </div>
              <div class="col-6">
                <div class="form-inline">
                  <label for="convertedDate" i18n>Converted:</label>
                  <span id="convertedDate">{{job.quote_Converted | date: 'M/d/yyyy'}}</span>
                </div>
                <div class="form-inline">
                  <label for="workOrders" i18n>Work Orders:</label>
                  <span id="scheduledDate">{{job.workOrders.length}}</span>
                </div>
                <div class="form-inline">
                  <label class="bold" i18n>Job Type:</label>
                  <span>{{job.jobType?.jobType_Desc}}</span>
                </div>
                <div class="form-inline">
                  <label class="bold" i18n>Job Status:</label>
                  <span class="text-success">{{getJobStatusName(job)}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
